import { render, staticRenderFns } from "./NewMarket.vue?vue&type=template&id=3cc1a45f&"
import script from "./NewMarket.vue?vue&type=script&lang=js&"
export * from "./NewMarket.vue?vue&type=script&lang=js&"
import style0 from "./NewMarket.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports